import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import ReactTooltip from "react-tooltip"

import Panel from "shared/components/Panel"

import ParcelsListTableDesktop from "./ParcelsListTableDesktop"
import ParcelsListTableMobile from "./ParcelsListTableMobile"

class ParcelsList extends PureComponent {
  static propTypes = {
    parcelsList: PropTypes.array.isRequired,
    errorsList: PropTypes.array.isRequired,
  }
  static contextTypes = {
    t: PropTypes.func.isRequired,
  }
  componentDidMount() {
    ReactTooltip.rebuild()
  }

  render() {
    const { parcelsList, errorsList } = this.props
    const { t: translate } = this.context

    return (
      <Panel>
        <h1 className="w400 fs-12">{translate("Tracking Statuses")}</h1>
        <div className="content">
          <ParcelsListTableDesktop parcels={parcelsList} errors={errorsList}></ParcelsListTableDesktop>
          <ParcelsListTableMobile parcels={parcelsList} errors={errorsList}></ParcelsListTableMobile>
        </div>
      </Panel>
    )
  }
}

export default ParcelsList



// WEBPACK FOOTER //
// ./src/views/Parcels/components/ParcelsList/ParcelsList.js